import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MEMBERSHIP_CONTACT_EMAIL = createFcmDetails('membership_contact_email', {
	owner: 'Payments',
	context: 'PPMU Thank You page',
	description: 'Contact email to put in the generated receipt. Defaults to help@change.org.',
	import: false,
});
